import { forwardRef, type SVGProps } from "react";
// eslint-disable-next-line react/display-name
const SvgStatusUnsaved = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path
        d="M7.52014 0C3.38014 0 0.0201416 3.36 0.0201416 7.5C0.0201416 11.64 3.38014 15 7.52014 15C11.6601 15 15.0201 11.64 15.0201 7.5C15.0201 3.36 11.6601 0 7.52014 0ZM11.2701 8.25H3.77014V6.75H11.2701V8.25Z"
        fill="#F0567A"
      />
    </g>
  </svg>
));
export default SvgStatusUnsaved;
